import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { ConvertInvoiceToRaStatuses } from '../Enums/ConvertInvoiceToRaStatuses.enum';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { AdditionalRequiredField } from './AdditionalRequiredField.entity';
import { AddressConnection } from './AddressConnection.entity';
import { Appearance } from './Appearance.entity';
import { Appointment } from './Appointment.entity';
import { AppointmentAttachment } from './AppointmentAttachment.entity';
import { AppointmentState } from './AppointmentState.entity';
import { Article } from './Article.entity';
import { BaseDataLanguage } from './BaseDataLanguage.entity';
import { BatchBillingServiceContractsResult } from './BatchBillingServiceContractsResult.entity';
import { BatchBillingServiceContractsSettings } from './BatchBillingServiceContractsSettings.entity';
import { BillProjectHoursResult } from './BillProjectHoursResult.entity';
import { BzObjectConversionResult } from './BzObjectConversionResult.entity';
import { BzObjectMutationResponse } from './BzObjectMutationResponse.entity';
import { CallMemo } from './CallMemo.entity';
import { CallMemoAttachment } from './CallMemoAttachment.entity';
import { CheckList } from './CheckList.entity';
import { CheckListPosition } from './CheckListPosition.entity';
import { CommentEvent } from './CommentEvent.entity';
import { Contact } from './Contact.entity';
import { ConvertTempFileResult } from './ConvertTempFileResult.entity';
import { CostCenter } from './CostCenter.entity';
import { Currency } from './Currency.entity';
import { Customer } from './Customer.entity';
import { DeleteEntityResult } from './DeleteEntityResult.entity';
import { Department } from './Department.entity';
import { Document } from './Document.entity';
import { DuplicateResponse } from './DuplicateResponse.entity';
import { EMail } from './EMail.entity';
import { EMailSignature } from './EMailSignature.entity';
import { EMailTemplate } from './EMailTemplate.entity';
import { EMailTemplateGroup } from './EMailTemplateGroup.entity';
import { ExchangeMailClientConfig } from './ExchangeMailClientConfig.entity';
import { ExchangeMailConfigTestResult } from './ExchangeMailConfigTestResult.entity';
import { FavoriteItem } from './FavoriteItem.entity';
import { FileServiceProviderConfig } from './FileServiceProviderConfig.entity';
import { FullUser } from './FullUser.entity';
import { Group } from './Group.entity';
import { Holiday } from './Holiday.entity';
import { InboundInvoice } from './InboundInvoice.entity';
import { IncomingMailBlockedSender } from './IncomingMailBlockedSender.entity';
import { Layout } from './Layout.entity';
import { LedgerAccount } from './LedgerAccount.entity';
import { Letter } from './Letter.entity';
import { LookUp } from './LookUp.entity';
import { MailboxContent } from './MailboxContent.entity';
import { ModifyShadowBzObjectResult } from './ModifyShadowBzObjectResult.entity';
import { ModifyShadowREResult } from './ModifyShadowREResult.entity';
import { Note } from './Note.entity';
import { NoteAttachment } from './NoteAttachment.entity';
import { NumberingLogic } from './NumberingLogic.entity';
import { ObjectLockResult } from './ObjectLockResult.entity';
import { OciWebShop } from './OciWebShop.entity';
import { OcrInvoiceData } from './OcrInvoiceData.entity';
import { ProcessWordTemplateResult } from './ProcessWordTemplateResult.entity';
import { Project } from './Project.entity';
import { ProjectAccessGroup } from './ProjectAccessGroup.entity';
import { ProjectAccessRights } from './ProjectAccessRights.entity';
import { ProjectDirectoryDefinition } from './ProjectDirectoryDefinition.entity';
import { ProjectProcess } from './ProjectProcess.entity';
import { Ra } from './Ra.entity';
import { RaPayment } from './RaPayment.entity';
import { SalesOpportunities } from './SalesOpportunities.entity';
import { SalesOpportunityRatingStatus } from './SalesOpportunityRatingStatus.entity';
import { Salutation } from './Salutation.entity';
import { SavedListFilter } from './SavedListFilter.entity';
import { SaveSendMailJob } from './SaveSendMailJob.entity';
import { SendEMailResult } from './SendEMailResult.entity';
import { SetMfaModeResponse } from './SetMfaModeResponse.entity';
import { SetUserPresenceResult } from './SetUserPresenceResult.entity';
import { Sickness } from './Sickness.entity';
import { Supplier } from './Supplier.entity';
import { Task } from './Task.entity';
import { TaskAttachment } from './TaskAttachment.entity';
import { TempFile } from './TempFile.entity';
import { Tenant } from './Tenant.entity';
import { TextBuildingBlock } from './TextBuildingBlock.entity';
import { Ticket } from './Ticket.entity';
import { TicketFilter } from './TicketFilter.entity';
import { TimeTracking } from './TimeTracking.entity';
import { TravelReceipts } from './TravelReceipts.entity';
import { Unit } from './Unit.entity';
import { User } from './User.entity';
import { UserCollection } from './UserCollection.entity';
import { UserPresenceTimeInfoItem } from './UserPresenceTimeInfoItem.entity';
import { Vacation } from './Vacation.entity';
import { ValidateSetMfaModeResponse } from './ValidateSetMfaModeResponse.entity';
import { VaultSettingItem } from './VaultSettingItem.entity';
import { VisitationReport } from './VisitationReport.entity';
import { WebShopDefinition } from './WebShopDefinition.entity';
import { WordDocumentTemplate } from './WordDocumentTemplate.entity';
import { WordLetterTemplate } from './WordLetterTemplate.entity';

export class Mutation<T extends EMode = EMode.entity> {
  /** Alias: deleteSetting */
  deleteSetting?: boolean;
  /** Alias: setSetting */
  setSetting?: VaultSettingItem<T>;
  /** Alias: upsertAufgabe */
  upsertTask?: Task<T>;
  /** Alias: upsertBrief */
  upsertLetter?: Letter<T>;
  /** Alias: upsertDokument */
  upsertDocument?: Document<T>;
  /** Alias: upsertKunde */
  upsertCustomer?: Customer<T>;
  /** Alias: upsertLayout */
  upsertLayout?: Layout<T>;
  /** Alias: upsertLieferant */
  upsertSupplier?: Supplier<T>;
  /** Alias: upsertNotiz */
  upsertNote?: Note<T>;
  /** Alias: upsertProjekt */
  upsertProject?: Project<T>;
  /** Alias: upsertTelefonat */
  upsertPhoneCall?: CallMemo<T>;
  /** Alias: upsertTermin */
  upsertAppointment?: Appointment<T>;
  /** Alias: createShadowBzObject */
  createShadowBzObject?: ModifyShadowBzObjectResult<T>;
  /** Alias: deleteShadowBzObject */
  deleteShadowBzObject?: boolean;
  /** Alias: modifyShadowBzObject */
  modifyShadowBzObject?: ModifyShadowBzObjectResult<T>;
  /** Alias: persistShadowBzObject */
  persistShadowBzObject?: ModifyShadowBzObjectResult<T>;
  /** Alias: setObjectLock */
  setObjectLock?: ObjectLockResult<T>;
  /** Alias: removeObjectLock */
  removeObjectLock?: boolean;
  /** Alias: upsertZeiterfassung */
  upsertZeiterfassung?: TimeTracking<T>;
  /** Alias: upsertCheckliste */
  upsertCheckList?: CheckList<T>;
  /** Alias: upsertChecklistePosition */
  upsertCheckListPosition?: CheckListPosition<T>;
  /** Alias: upsertAnsprechpartner */
  upsertContact?: Contact<T>;
  /** Alias: upsertAdressVerknuepfung */
  upsertAddressConnection?: AddressConnection<T>;
  /** Alias: deleteEntity */
  deleteEntity?: DeleteEntityResult<T>;
  /** Alias: modifyShadowBzObjectAddPosition */
  modifyShadowBzObjectAddPosition?: ModifyShadowBzObjectResult<T>;
  /** Alias: modifyShadowBzObjectRemovePosition */
  modifyShadowBzObjectRemovePosition?: ModifyShadowBzObjectResult<T>;
  /** Alias: modifyShadowBzObjectMovePosition */
  modifyShadowBzObjectMovePosition?: ModifyShadowBzObjectResult<T>;
  /** Alias: upsertEMail */
  upsertEMail?: EMail<T>;
  /** Alias: upsertTelefonatAnhang */
  upsertCallMemoAttachment?: CallMemoAttachment<T>;
  /** Alias: upsertTerminAnhang */
  upsertAppointmentAttachment?: AppointmentAttachment<T>;
  /** Alias: upsertNotizAnhang */
  upsertNoteAttachment?: NoteAttachment<T>;
  /** Alias: upsertAufgabeAnhang */
  upsertTaskAttachment?: TaskAttachment<T>;
  /** Alias: sendMail */
  sendMail?: SendEMailResult<T>;
  /** Alias: upsertEMailVorlage */
  upsertEMailTemplate?: EMailTemplate<T>;
  /** Alias: upsertEMailSignatur */
  upsertEMailSignature?: EMailSignature<T>;
  /** Alias: modifyShadowBzObjectModifyPosition */
  modifyShadowBzObjectModifyPosition?: ModifyShadowBzObjectResult<T>;
  /** Alias: upsertTicket */
  upsertTicket?: Ticket<T>;
  /** Alias: upsertBesuchsbericht */
  upsertBesuchsbericht?: VisitationReport<T>;
  /** Alias: interpretTempFileAsIncommingInvoice */
  interpretedTempFileAsIncommingInvoice?: OcrInvoiceData<T>;
  /** Alias: processWordTemplate */
  processWordTemplate?: ProcessWordTemplateResult<T>;
  /** Alias: setUserPresenceTimestamp */
  setUserPresenceTimestamp?: SetUserPresenceResult<T>;
  /** Alias: modifyAppearance */
  modifyAppearance?: Appearance<T>;
  /** Alias: modifyUserAppearanceConfiguration */
  modifyUserAppearanceConfiguration?: Appearance<T>;
  /** Alias: createShadowRe */
  createShadowRe?: ModifyShadowREResult<T>;
  /** Alias: deleteShadowRe */
  deleteShadowRe?: boolean;
  /** Alias: modifyShadowREModifyLine */
  modifyShadowREModifyLine?: ModifyShadowREResult<T>;
  /** Alias: modifyShadowReAddBuchung */
  modifyShadowReAddBuchung?: ModifyShadowREResult<T>;
  /** Alias: modifyShadowReRemoveBuchung */
  modifyShadowReRemoveBuchung?: ModifyShadowREResult<T>;
  /** Alias: persistShadowRe */
  persistShadowRe?: ModifyShadowREResult<T>;
  /** Alias: upsertUrlaub */
  upsertVacation?: Vacation<T>;
  /** Alias: upsertKrankheit */
  upsertSickness?: Sickness<T>;
  /** Alias: addComment */
  addComment?: CommentEvent<T>;
  /** Alias: startJobSaveSendMail */
  startJobSaveSendMail?: SaveSendMailJob<T>;
  /** Alias: upsertDokumentForPreview */
  upsertDocumentForPreview?: string;
  /** Alias: upsertBriefForPreview */
  upsertLetterForPreview?: string;
  /** Alias: upsertVacationRequest */
  upsertVacationRequest?: string;
  /** Alias: upsertKommtGehtZeitstempel */
  upsertKommtGehtZeitstempel?: UserPresenceTimeInfoItem<T>;
  /** Alias: upsertUserCollection */
  upsertUserCollection?: UserCollection<T>;
  /** Alias: upsertEMailTemplateGroup */
  upsertEMailTemplateGroup?: EMailTemplateGroup<T>;
  /** Alias: modifyShadowRe */
  modifyShadowRe?: ModifyShadowREResult<T>;
  /** Alias: upsertTextBuildingBlock */
  upsertTextBuildingBlock?: TextBuildingBlock<T>;
  /** Alias: upsertTicketFilter */
  upsertTicketFilter?: TicketFilter<T>;
  /** Alias: createTempFile */
  createTempFile?: TempFile<T>;
  /** Alias: upsertSavedListFilter */
  upsertSavedListFilter?: SavedListFilter<T>;
  /** Alias: upsertVerkaufschance */
  upsertVerkaufschance?: SalesOpportunities<T>;
  /** Alias: assignMail */
  assignMail?: MailboxContent<T>;
  /** Alias: ignoreMail */
  ignoreMail?: boolean;
  /** Alias: setMailState */
  setMailState?: boolean;
  /** Alias: setProjectAccessRights */
  setProjectAccessRights?: ProjectAccessRights<T>[];
  /** Alias: unignoreMail */
  unignoreMail?: boolean;
  /** Alias: setNotificationRead */
  setNotificationRead?: boolean;
  /** Alias: updateBenutzer */
  updateBenutzer?: User<T>;
  /** Alias: upsertSalesOpportunityRatingStatus */
  upsertSalesOpportunityRatingStatus?: SalesOpportunityRatingStatus<T>;
  /** Alias: upsertProjectAccessGroup */
  upsertProjectAccessGroup?: ProjectAccessGroup<T>;
  /** Alias: archiveMail */
  archiveMail?: boolean;
  /** Alias: deleteMail */
  deleteMail?: boolean;
  /** Alias: convertBzObject */
  convertBzObject?: BzObjectConversionResult<T>;
  /** Alias: convertTempFile */
  convertTempFile?: ConvertTempFileResult<T>[];
  /** Alias: convertMailToTempfile */
  convertMailToTempfile?: TempFile<T>;
  /** Alias: assignMailToObject */
  assignMailToObject?: MailboxContent<T>;
  /** Alias: duplicateEntity */
  duplicateEntity?: DuplicateResponse<T>;
  /** Alias: upsertOutgoingInvoiceLedger */
  upsertOutgoingInvoiceLedger?: Ra<T>;
  /** Alias: upsertIncomingInvoiceLedger */
  upsertIncomingInvoiceLedger?: InboundInvoice<T>;
  /** Alias: upsertLetterTemplate */
  upsertLetterTemplate?: WordLetterTemplate<T>;
  /** Alias: upsertSimpleReceipt */
  upsertSimpleReceipt?: TravelReceipts<T>;
  /** Alias: upsertDocumentTemplate */
  upsertDocumentTemplate?: WordDocumentTemplate<T>;
  /** Alias: upsertIncomingMailBlockedSender */
  upsertIncomingMailBlockedSender?: IncomingMailBlockedSender<T>;
  /** Alias: updateUserMfaMode */
  updateUserMfaMode?: SetMfaModeResponse<T>;
  /** Alias: validateUserMfaMode */
  validateUserMfaMode?: ValidateSetMfaModeResponse<T>;
  /** Alias: editComment */
  editComment?: CommentEvent<T>;
  /** Alias: upsertProjectDirectoryDefinition */
  upsertProjectDirectoryDefinition?: ProjectDirectoryDefinition<T>;
  /** Alias: upsertProjectStep */
  upsertProjectStep?: ProjectProcess<T>;
  /** Alias: upsertRaPayment */
  upsertRaPayment?: RaPayment<T>;
  /** Alias: removePersonalSettings */
  removePersonalSettings?: boolean;
  /** Alias: mutateBzObjects */
  mutateBzObjects?: BzObjectMutationResponse<T>;
  /** Alias: upsertArticle */
  upsertArticle?: Article<T>;
  /** Alias: upsertReport2 */
  upsertReport2?: string;
  /** Alias: invoiceToOutgoingInvoiceLedger */
  invoiceToOutgoingInvoiceLedger?: ConvertInvoiceToRaStatuses;
  /** Alias: invoiceToXInvoice */
  invoiceToXInvoice?: TempFile<T>;
  /** Alias: attachZugferdToTempfile */
  attachZugferdToTempfile?: TempFile<T>;
  /** Alias: xInvoiceToPdf */
  xInvoiceToPdf?: TempFile<T>;
  /** Alias: relevantArticleAttachmentsToTempFiles */
  relevantArticleAttachmentsToTempFiles?: TempFile<T>[];
  /** Alias: upsertFullUser */
  upsertFullUser?: FullUser<T>;
  /** Alias: mutateProjectGroups */
  mutateProjectGroups?: Group<T>[];
  /** Alias: upsertAbteilung */
  upsertAbteilung?: Department<T>;
  /** Alias: mutateSupplierGroups */
  mutateSupplierGroups?: Group<T>[];
  /** Alias: mutateCustomerGroups */
  mutateCustomerGroups?: Group<T>[];
  /** Alias: mutateArticleGroups */
  mutateArticleGroups?: Group<T>[];
  /** Alias: setAdditionalRequiredField */
  setAdditionalRequiredField?: AdditionalRequiredField<T>[];
  /** Alias: convertBzObjectToSalesOpportunity */
  convertBzObjectToSalesOpportunity?: SalesOpportunities<T>;
  /** Alias: convertToSalesOffer */
  convertToSalesOffer?: BzObjectConversionResult<T>;
  /** Alias: setFavoriteItem */
  setFavoriteItem?: FavoriteItem<T>;
  /** Alias: upsertDocumentTemplateGroup */
  upsertDocumentTemplateGroup?: string;
  /** Alias: upsertLetterTemplateGroup */
  upsertLetterTemplateGroup?: string;
  /** Alias: modifyShadowBzObjectAddPositionPartialInvoice */
  modifyShadowBzObjectAddPositionPartialInvoice?: ModifyShadowBzObjectResult<T>;
  /** Alias: upsertOciWebShop */
  upsertOciWebShop?: OciWebShop<T>;
  /** Alias: deleteOciWebshopRequest */
  deleteOciWebshopRequest?: boolean;
  /** Alias: mutateTextModuleGroups */
  mutateTextModuleGroups?: Group<T>[];
  /** Alias: mutateSalesOpportunityGroups */
  mutateSalesOpportunityGroups?: Group<T>[];
  /** Alias: resolveOciRequest */
  resolveOciRequest?: ModifyShadowBzObjectResult<T>;
  /** Alias: resetUserMfaMode */
  resetUserMfaMode?: boolean;
  /** Alias: upsertPublicHolidays */
  upsertPublicHolidays?: Holiday<T>;
  /** Alias: upsertAppointmentStatus */
  upsertAppointmentStatus?: AppointmentState<T>;
  /** Alias: upsertBatchBillingServiceContractsSettings */
  upsertBatchBillingServiceContractsSettings?: BatchBillingServiceContractsSettings<T>;
  /** Alias: batchBillingServiceContracts */
  batchBillingServiceContracts?: BatchBillingServiceContractsResult<T>;
  /** Alias: upsertCostCenter */
  upsertCostCenter?: CostCenter<T>;
  /** Alias: upsertTenant */
  upsertTenant?: Tenant<T>;
  /** Alias: upsertUnit */
  upsertUnit?: Unit<T>;
  /** Alias: upsertNumberRule */
  upsertNumberRule?: NumberingLogic<T>;
  setGeneralEwsSettings?: ExchangeMailClientConfig<T>;
  /** Alias: testGeneralEwsSettings */
  testGeneralEwsSettings?: ExchangeMailConfigTestResult<T>;
  /** Alias: upsertGeneralLedgeAccount */
  upsertGeneralLedgeAccount?: LedgerAccount<T>;
  /** Alias: upsertSalutation */
  upsertSalutation?: Salutation<T>;
  /** Alias: upsertLanguage */
  upsertLanguage?: BaseDataLanguage<T>;
  /** Alias: upsertCurrency */
  upsertCurrency?: Currency<T>;
  /** Alias: upsertLookup */
  upsertLookup?: LookUp<T>;
  /** Alias: deleteWebshopRequest */
  deleteWebshopRequest?: boolean;
  /** Alias: upsertWebShopDefintion */
  upsertWebShopDefintion?: WebShopDefinition<T>;
  /** Alias: resolveWebShopRequest */
  resolveWebShopRequest?: ModifyShadowBzObjectResult<T>;
  /** Alias: billProjectHours */
  billProjectHours?: BillProjectHoursResult<T>;
  /** Alias: upsertFileServiceProvider */
  upsertFileServiceProvider?: FileServiceProviderConfig<T>;
  /** Alias: deleteFileServiceProvider */
  deleteFileServiceProvider?: boolean;

  __typename?: string;
}

const fields: FieldDefinitions<Mutation> = {
  deleteSetting: {
    alias: 'deleteSetting',
  },
  setSetting: {
    alias: 'setSetting',
    entity: Entities.vaultSettingItem,
  },
  upsertTask: {
    alias: 'upsertAufgabe',
    entity: Entities.task,
  },
  upsertLetter: {
    alias: 'upsertBrief',
    entity: Entities.letter,
  },
  upsertDocument: {
    alias: 'upsertDokument',
    entity: Entities.document,
  },
  upsertCustomer: {
    alias: 'upsertKunde',
    entity: Entities.customer,
  },
  upsertLayout: {
    alias: 'upsertLayout',
    entity: Entities.layout,
  },
  upsertSupplier: {
    alias: 'upsertLieferant',
    entity: Entities.supplier,
  },
  upsertNote: {
    alias: 'upsertNotiz',
    entity: Entities.note,
  },
  upsertProject: {
    alias: 'upsertProjekt',
    entity: Entities.project,
  },
  upsertPhoneCall: {
    alias: 'upsertTelefonat',
    entity: Entities.callMemo,
  },
  upsertAppointment: {
    alias: 'upsertTermin',
    entity: Entities.appointment,
  },
  createShadowBzObject: {
    alias: 'createShadowBzObject',
    entity: Entities.modifyShadowBzObjectResult,
  },
  deleteShadowBzObject: {
    alias: 'deleteShadowBzObject',
  },
  modifyShadowBzObject: {
    alias: 'modifyShadowBzObject',
    entity: Entities.modifyShadowBzObjectResult,
  },
  persistShadowBzObject: {
    alias: 'persistShadowBzObject',
    entity: Entities.modifyShadowBzObjectResult,
  },
  setObjectLock: {
    alias: 'setObjectLock',
    entity: Entities.objectLockResult,
  },
  removeObjectLock: {
    alias: 'removeObjectLock',
  },
  upsertZeiterfassung: {
    alias: 'upsertZeiterfassung',
    entity: Entities.timeTracking,
  },
  upsertCheckList: {
    alias: 'upsertCheckliste',
    entity: Entities.checkList,
  },
  upsertCheckListPosition: {
    alias: 'upsertChecklistePosition',
    entity: Entities.checkListPosition,
  },
  upsertContact: {
    alias: 'upsertAnsprechpartner',
    entity: Entities.contact,
  },
  upsertAddressConnection: {
    alias: 'upsertAdressVerknuepfung',
    entity: Entities.addressConnection,
  },
  deleteEntity: {
    alias: 'deleteEntity',
    entity: Entities.deleteEntityResult,
  },
  modifyShadowBzObjectAddPosition: {
    alias: 'modifyShadowBzObjectAddPosition',
    entity: Entities.modifyShadowBzObjectResult,
  },
  modifyShadowBzObjectRemovePosition: {
    alias: 'modifyShadowBzObjectRemovePosition',
    entity: Entities.modifyShadowBzObjectResult,
  },
  modifyShadowBzObjectMovePosition: {
    alias: 'modifyShadowBzObjectMovePosition',
    entity: Entities.modifyShadowBzObjectResult,
  },
  upsertEMail: {
    alias: 'upsertEMail',
    entity: Entities.eMail,
  },
  upsertCallMemoAttachment: {
    alias: 'upsertTelefonatAnhang',
    entity: Entities.callMemoAttachment,
  },
  upsertAppointmentAttachment: {
    alias: 'upsertTerminAnhang',
    entity: Entities.appointmentAttachment,
  },
  upsertNoteAttachment: {
    alias: 'upsertNotizAnhang',
    entity: Entities.noteAttachment,
  },
  upsertTaskAttachment: {
    alias: 'upsertAufgabeAnhang',
    entity: Entities.taskAttachment,
  },
  sendMail: {
    alias: 'sendMail',
    entity: Entities.sendEMailResult,
  },
  upsertEMailTemplate: {
    alias: 'upsertEMailVorlage',
    entity: Entities.eMailTemplate,
  },
  upsertEMailSignature: {
    alias: 'upsertEMailSignatur',
    entity: Entities.eMailSignature,
  },
  modifyShadowBzObjectModifyPosition: {
    alias: 'modifyShadowBzObjectModifyPosition',
    entity: Entities.modifyShadowBzObjectResult,
  },
  upsertTicket: {
    alias: 'upsertTicket',
    entity: Entities.ticket,
  },
  upsertBesuchsbericht: {
    alias: 'upsertBesuchsbericht',
    entity: Entities.visitationReport,
  },
  interpretedTempFileAsIncommingInvoice: {
    alias: 'interpretTempFileAsIncommingInvoice',
    entity: Entities.ocrInvoiceData,
  },
  processWordTemplate: {
    alias: 'processWordTemplate',
    entity: Entities.processWordTemplateResult,
  },
  setUserPresenceTimestamp: {
    alias: 'setUserPresenceTimestamp',
    entity: Entities.setUserPresenceResult,
  },
  modifyAppearance: {
    alias: 'modifyAppearance',
    entity: Entities.appearance,
  },
  modifyUserAppearanceConfiguration: {
    alias: 'modifyUserAppearanceConfiguration',
    entity: Entities.appearance,
  },
  createShadowRe: {
    alias: 'createShadowRe',
    entity: Entities.modifyShadowREResult,
  },
  deleteShadowRe: {
    alias: 'deleteShadowRe',
  },
  modifyShadowREModifyLine: {
    alias: 'modifyShadowREModifyLine',
    entity: Entities.modifyShadowREResult,
  },
  modifyShadowReAddBuchung: {
    alias: 'modifyShadowReAddBuchung',
    entity: Entities.modifyShadowREResult,
  },
  modifyShadowReRemoveBuchung: {
    alias: 'modifyShadowReRemoveBuchung',
    entity: Entities.modifyShadowREResult,
  },
  persistShadowRe: {
    alias: 'persistShadowRe',
    entity: Entities.modifyShadowREResult,
  },
  upsertVacation: {
    alias: 'upsertUrlaub',
    entity: Entities.vacation,
  },
  upsertSickness: {
    alias: 'upsertKrankheit',
    entity: Entities.sickness,
  },
  addComment: {
    alias: 'addComment',
    entity: Entities.commentEvent,
  },
  startJobSaveSendMail: {
    alias: 'startJobSaveSendMail',
    entity: Entities.saveSendMailJob,
  },
  upsertDocumentForPreview: {
    alias: 'upsertDokumentForPreview',
  },
  upsertLetterForPreview: {
    alias: 'upsertBriefForPreview',
  },
  upsertVacationRequest: {
    alias: 'upsertVacationRequest',
  },
  upsertKommtGehtZeitstempel: {
    alias: 'upsertKommtGehtZeitstempel',
    entity: Entities.userPresenceTimeInfoItem,
  },
  upsertUserCollection: {
    alias: 'upsertUserCollection',
    entity: Entities.userCollection,
  },
  upsertEMailTemplateGroup: {
    alias: 'upsertEMailTemplateGroup',
    entity: Entities.eMailTemplateGroup,
  },
  modifyShadowRe: {
    alias: 'modifyShadowRe',
    entity: Entities.modifyShadowREResult,
  },
  upsertTextBuildingBlock: {
    alias: 'upsertTextBuildingBlock',
    entity: Entities.textBuildingBlock,
  },
  upsertTicketFilter: {
    alias: 'upsertTicketFilter',
    entity: Entities.ticketFilter,
  },
  createTempFile: {
    alias: 'createTempFile',
    entity: Entities.tempFile,
  },
  upsertSavedListFilter: {
    alias: 'upsertSavedListFilter',
    entity: Entities.savedListFilter,
  },
  upsertVerkaufschance: {
    alias: 'upsertVerkaufschance',
    entity: Entities.salesOpportunities,
  },
  assignMail: {
    alias: 'assignMail',
    entity: Entities.mailboxContent,
  },
  ignoreMail: {
    alias: 'ignoreMail',
  },
  setMailState: {
    alias: 'setMailState',
  },
  setProjectAccessRights: {
    alias: 'setProjectAccessRights',
    entity: Entities.projectAccessRights,
  },
  unignoreMail: {
    alias: 'unignoreMail',
  },
  setNotificationRead: {
    alias: 'setNotificationRead',
  },
  updateBenutzer: {
    alias: 'updateBenutzer',
    entity: Entities.user,
  },
  upsertSalesOpportunityRatingStatus: {
    alias: 'upsertSalesOpportunityRatingStatus',
    entity: Entities.salesOpportunityRatingStatus,
  },
  upsertProjectAccessGroup: {
    alias: 'upsertProjectAccessGroup',
    entity: Entities.projectAccessGroup,
  },
  archiveMail: {
    alias: 'archiveMail',
  },
  deleteMail: {
    alias: 'deleteMail',
  },
  convertBzObject: {
    alias: 'convertBzObject',
    entity: Entities.bzObjectConversionResult,
  },
  convertTempFile: {
    alias: 'convertTempFile',
    entity: Entities.convertTempFileResult,
  },
  convertMailToTempfile: {
    alias: 'convertMailToTempfile',
    entity: Entities.tempFile,
  },
  assignMailToObject: {
    alias: 'assignMailToObject',
    entity: Entities.mailboxContent,
  },
  duplicateEntity: {
    alias: 'duplicateEntity',
    entity: Entities.duplicateResponse,
  },
  upsertOutgoingInvoiceLedger: {
    alias: 'upsertOutgoingInvoiceLedger',
    entity: Entities.ra,
  },
  upsertIncomingInvoiceLedger: {
    alias: 'upsertIncomingInvoiceLedger',
    entity: Entities.inboundInvoice,
  },
  upsertLetterTemplate: {
    alias: 'upsertLetterTemplate',
    entity: Entities.wordLetterTemplate,
  },
  upsertSimpleReceipt: {
    alias: 'upsertSimpleReceipt',
    entity: Entities.travelReceipts,
  },
  upsertDocumentTemplate: {
    alias: 'upsertDocumentTemplate',
    entity: Entities.wordDocumentTemplate,
  },
  upsertIncomingMailBlockedSender: {
    alias: 'upsertIncomingMailBlockedSender',
    entity: Entities.incomingMailBlockedSender,
  },
  updateUserMfaMode: {
    alias: 'updateUserMfaMode',
    entity: Entities.setMfaModeResponse,
  },
  validateUserMfaMode: {
    alias: 'validateUserMfaMode',
    entity: Entities.validateSetMfaModeResponse,
  },
  editComment: {
    alias: 'editComment',
    entity: Entities.commentEvent,
  },
  upsertProjectDirectoryDefinition: {
    alias: 'upsertProjectDirectoryDefinition',
    entity: Entities.projectDirectoryDefinition,
  },
  upsertProjectStep: {
    alias: 'upsertProjectStep',
    entity: Entities.projectProcess,
  },
  upsertRaPayment: {
    alias: 'upsertRaPayment',
    entity: Entities.raPayment,
  },
  removePersonalSettings: {
    alias: 'removePersonalSettings',
  },
  mutateBzObjects: {
    alias: 'mutateBzObjects',
    entity: Entities.bzObjectMutationResponse,
  },
  upsertArticle: {
    alias: 'upsertArticle',
    entity: Entities.article,
  },
  upsertReport2: {
    alias: 'upsertReport2',
  },
  invoiceToOutgoingInvoiceLedger: {
    alias: 'invoiceToOutgoingInvoiceLedger',
  },
  invoiceToXInvoice: {
    alias: 'invoiceToXInvoice',
    entity: Entities.tempFile,
  },
  attachZugferdToTempfile: {
    alias: 'attachZugferdToTempfile',
    entity: Entities.tempFile,
  },
  xInvoiceToPdf: {
    alias: 'xInvoiceToPdf',
    entity: Entities.tempFile,
  },
  relevantArticleAttachmentsToTempFiles: {
    alias: 'relevantArticleAttachmentsToTempFiles',
    entity: Entities.tempFile,
  },
  upsertFullUser: {
    alias: 'upsertFullUser',
    entity: Entities.fullUser,
  },
  mutateProjectGroups: {
    alias: 'mutateProjectGroups',
    entity: Entities.group,
  },
  upsertAbteilung: {
    alias: 'upsertAbteilung',
    entity: Entities.department,
  },
  mutateSupplierGroups: {
    alias: 'mutateSupplierGroups',
    entity: Entities.group,
  },
  mutateCustomerGroups: {
    alias: 'mutateCustomerGroups',
    entity: Entities.group,
  },
  mutateArticleGroups: {
    alias: 'mutateArticleGroups',
    entity: Entities.group,
  },
  setAdditionalRequiredField: {
    alias: 'setAdditionalRequiredField',
    entity: Entities.additionalRequiredField,
  },
  convertBzObjectToSalesOpportunity: {
    alias: 'convertBzObjectToSalesOpportunity',
    entity: Entities.salesOpportunities,
  },
  convertToSalesOffer: {
    alias: 'convertToSalesOffer',
    entity: Entities.bzObjectConversionResult,
  },
  setFavoriteItem: {
    alias: 'setFavoriteItem',
    entity: Entities.favoriteItem,
  },
  upsertDocumentTemplateGroup: {
    alias: 'upsertDocumentTemplateGroup',
  },
  upsertLetterTemplateGroup: {
    alias: 'upsertLetterTemplateGroup',
  },
  upsertOciWebShop: {
    alias: 'upsertOciWebShop',
    entity: Entities.ociWebShop,
  },
  modifyShadowBzObjectAddPositionPartialInvoice: {
    alias: 'modifyShadowBzObjectAddPositionPartialInvoice',
    entity: Entities.modifyShadowBzObjectResult,
  },
  deleteOciWebshopRequest: {
    alias: 'deleteOciWebshopRequest',
  },
  mutateTextModuleGroups: {
    alias: 'mutateTextModuleGroups',
    entity: Entities.group,
  },
  mutateSalesOpportunityGroups: {
    alias: 'mutateSalesOpportunityGroups',
    entity: Entities.group,
  },
  resolveOciRequest: {
    alias: 'resolveOciRequest',
    entity: Entities.modifyShadowBzObjectResult,
  },
  resetUserMfaMode: {
    alias: 'resetUserMfaMode',
  },
  upsertPublicHolidays: {
    alias: 'upsertPublicHolidays',
    entity: Entities.holiday,
  },
  upsertAppointmentStatus: {
    alias: 'upsertAppointmentStatus',
    entity: Entities.appointmentState,
  },
  upsertBatchBillingServiceContractsSettings: {
    alias: 'upsertBatchBillingServiceContractsSettings',
    entity: Entities.batchBillingServiceContractsSettings,
  },
  batchBillingServiceContracts: {
    alias: 'batchBillingServiceContracts',
    entity: Entities.batchBillingServiceContractsResult,
  },
  upsertCostCenter: {
    alias: 'upsertCostCenter',
    entity: Entities.costCenter,
  },
  upsertTenant: {
    alias: 'upsertTenant',
    entity: Entities.tenant,
  },
  upsertUnit: {
    alias: 'upsertUnit',
    entity: Entities.unit,
  },
  upsertNumberRule: {
    alias: 'upsertNumberRule',
    entity: Entities.numberingLogic,
  },
  setGeneralEwsSettings: {
    alias: 'setGeneralEwsSettings',
    entity: Entities.exchangeMailClientConfig,
  },
  testGeneralEwsSettings: {
    alias: 'testGeneralEwsSettings',
    entity: Entities.exchangeMailConfigTestResult,
  },
  upsertGeneralLedgeAccount: {
    alias: 'upsertGeneralLedgeAccount',
    entity: Entities.ledgerAccount,
  },
  upsertSalutation: {
    alias: 'upsertSalutation',
    entity: Entities.salutation,
  },
  upsertLanguage: {
    alias: 'upsertLanguage',
    entity: Entities.baseDataLanguage,
  },
  upsertCurrency: {
    alias: 'upsertCurrency',
    entity: Entities.currency,
  },
  upsertLookup: {
    alias: 'upsertLookup',
    entity: Entities.lookUp,
  },
  deleteWebshopRequest: {
    alias: 'deleteWebshopRequest',
  },
  upsertWebShopDefintion: {
    alias: 'upsertWebShopDefintion',
    entity: Entities.webShopDefinition,
  },
  resolveWebShopRequest: {
    alias: 'resolveWebShopRequest',
    entity: Entities.modifyShadowBzObjectResult,
  },
  billProjectHours: {
    alias: 'billProjectHours',
    entity: Entities.billProjectHoursResult,
  },
  upsertFileServiceProvider: {
    alias: 'upsertFileServiceProvider',
    entity: Entities.fileServiceProviderConfig,
  },
  deleteFileServiceProvider: {
    alias: 'deleteFileServiceProvider',
  },
  __typename: {
    alias: '__typename',
  },
};

export const mutationEntityDefinition: EntitiyDefinition<Mutation> = {
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'Mutation',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
